import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import ErrorList from '../ErrorManagement/FormErrorLista';
import './sccs/FormInputSubmit.scss'

interface FormBotonSubmitProps {
    info: boolean;
    onSubmit: () => void;
    successCreate: boolean;
    successUpdate: boolean;
    errorCreate?: string;
    errorUpdate?: string;
    datosAPI?: { FechaAceptacionSolicitud?: string; EstadoFormulario?: number | string };
    disableSubmit?: boolean;
    label?: string;
    children?: React.ReactNode;
    infoLabel?: string;
    additionalInfoLabel?: string;
    additionalInfo?: React.ReactNode;
    additionalInfoInitExpand?: boolean;
    initExpand?: boolean;
    totalSizeDocs?: number;
    MaxSizeMB?: number;
    BloqueoForm?: number[] | null;
}

const FormBotonSubmit: React.FC<FormBotonSubmitProps> = ({
    info,
    onSubmit,
    successCreate,
    successUpdate,
    errorCreate,
    errorUpdate,
    datosAPI,
    disableSubmit = true,
    label = 'Acepto la información declarada.',
    children,
    infoLabel = 'INFORMACIÓN DE INTERÉS',
    additionalInfoLabel = 'INFORMACIÓN ADICIONAL',
    additionalInfo,
    additionalInfoInitExpand = false,
    initExpand = false, // Se debe mantener por default a false para que el usuario pueda leer la información antes de aceptar
    totalSizeDocs = 0,
    MaxSizeMB = 30,
    BloqueoForm = [3, 4, 5], //3 Estado Aceptado, 4 Rechazado, 5 estado cancelado
}) => {

    const { register, formState: { errors }, setValue } = useFormContext();
    const MAX_SIZE_MB = MaxSizeMB || 30;
    const isSizeExceeded = totalSizeDocs > MAX_SIZE_MB;
    const estadoFormularioValue = datosAPI?.EstadoFormulario;
    const isEstadoFormularioBloqueado =
        BloqueoForm !== null &&
        estadoFormularioValue !== undefined &&
        estadoFormularioValue !== null &&
        BloqueoForm.some((estadoBloqueado) => Number(estadoBloqueado) === Number(estadoFormularioValue));
    const [showSizeModal, setShowSizeModal] = useState(false);
    const [isAccordionopen, setIsAccordionOpen] = useState(initExpand);
    const [isAdditionalInfoOpen, setIsAdditionalInfoOpen] = useState(additionalInfoInitExpand);
    const [openedAccordion, setOpenedAccordion] = useState(initExpand);
    const [aceptarDeclaracion, setAceptarDeclaracion] = useState(true);

    const nowFormatted = new Intl.DateTimeFormat('es-ES', {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).format(new Date());

    const AceptarSolicitud = () => {
        setAceptarDeclaracion(!aceptarDeclaracion);
    };

    useEffect(() => {
        const isAccepted = Boolean(datosAPI?.FechaAceptacionSolicitud);

        setAceptarDeclaracion(!isAccepted);
        setValue('Acepto', isAccepted);
        setOpenedAccordion(initExpand ? true : isAccepted);

    }, [datosAPI?.FechaAceptacionSolicitud, setValue]);

    const isDisabled = Boolean(children) && !openedAccordion;

    useEffect(() => {
        if (isSizeExceeded) {
            setShowSizeModal(true);
        }
    }, [isSizeExceeded]);

    return (
        <>
            <div className="row mb-4">
                <div className="col-xl-12">
                    <FieldsetContainer legend="" disabled={false}>

                        {/* INFO (SOLO SI HAY CHILDREN) */}
                        {children && (
                            <div className='px-3 mb-3'>

                                <button
                                    className={`accordion-extra-info ${isAccordionopen ? 'open' : ''}`}
                                    onClick={() => {
                                        setIsAccordionOpen(!isAccordionopen);
                                        setOpenedAccordion(true);
                                    }}
                                    type='button'
                                >
                                    {infoLabel}
                                </button>

                                <div
                                    className={`accordion-extra-info-content ${isAccordionopen ? 'open' : ''}`}
                                    onClick={() => {
                                        setIsAccordionOpen(!isAccordionopen);
                                        setOpenedAccordion(true);
                                    }}
                                >
                                    <div>
                                        <div className="row mt-0">
                                            <div className="col-xl-12">
                                                <div className="card-link-block colored bright">
                                                    <div className="container-isextinct">
                                                        <h3 className="card-link_title fs-3 text-info p-1 pb-3">
                                                            {infoLabel}
                                                        </h3>
                                                        <div>
                                                            {children}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        )}



                        {/* TEXTO */}
                        <div className="mb-3">
                            <label className="wrap-label" htmlFor="Acepto">
                                {label}
                            </label>
                        </div>

                        {/* MENSAJE OBLIGATORIO */}
                        {children && (
                            <div>
                                <div className={`text-center ${openedAccordion ? 'success-obligatorio-text' : 'obligatorio-text'}`}>
                                    {openedAccordion
                                        ? 'INFORMACIÓN LEIDA'
                                        : 'ES OBLIGATORIO LEER LA INFORMACIÓN DE INTERÉS'}
                                </div>
                            </div>
                        )}

                        {/* CHECK + LÍNEAS (LABEL PARA CLICK TOTAL) */}
                        <label className={`accept-divider-wrapper ${isDisabled ? 'disabled' : ''}`}>

                            <input
                                type="checkbox"
                                id="Acepto"
                                className="accept-divider-checkbox mb-2"
                                disabled={isDisabled}
                                {...register('Acepto', { onChange: AceptarSolicitud })}
                            />

                            <span className="accept-divider-line accept-divider-line--left mb-2"></span>
                            <span className="accept-divider-line accept-divider-line--right mb-2"></span>

                        </label>

                        {/* FECHA */}
                        <div>
                            <div
                                className="mb-4 form-fecha-submit"
                                style={{ display: aceptarDeclaracion ? 'none' : 'block' }}
                            >
                                <div className="ml-1">
                                    {datosAPI?.FechaAceptacionSolicitud
                                        ? `Enviado el: ${new Intl.DateTimeFormat('es-ES', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: '2-digit',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                        }).format(new Date(datosAPI.FechaAceptacionSolicitud + 'Z'))}`
                                        : ''}
                                </div>
                            </div>
                        </div>

                    </FieldsetContainer>
                </div>
            </div>
            {additionalInfo && (
                <div className="additional-submit-info px-3 mb-3">
                    <button
                        className={`additional-submit-info__toggle ${isAdditionalInfoOpen ? 'open' : ''}`}
                        onClick={() => setIsAdditionalInfoOpen(!isAdditionalInfoOpen)}
                        type="button"
                    >
                        {additionalInfoLabel}
                    </button>

                    <div className={`additional-submit-info__content ${isAdditionalInfoOpen ? 'open' : ''}`}>
                        <div className="additional-submit-info__inner">
                            {additionalInfo}
                        </div>
                    </div>
                </div>
            )}
            {/* BOTÓN */}
            <div className="d-flex flex-wrap align-items-center gap-3 mt-3 mb-3">
                <button
                    className="btn-box btn-accent"
                    type="submit"
                    disabled={isSizeExceeded || disableSubmit || aceptarDeclaracion || isEstadoFormularioBloqueado}
                    onClick={onSubmit}
                >
                    {info ? 'CREAR FORMULARIO' : 'ACTUALIZAR FORMULARIO'}
                </button>
                {isSizeExceeded && (
                    <span
                        className="badge text-danger-li text-wrap text-start mb-0 ms-0"
                        style={{ cursor: 'default' }}
                        role="alert"
                    >
                        Formulario deshabilitado: los archivos superan el límite de {MAX_SIZE_MB} MB.
                    </span>
                )}
            </div>

            <br />

            {/* SUCCESS */}
            {(successCreate || successUpdate) && (
                <div className="paragraph text-success mb-4">
                    {datosAPI?.FechaAceptacionSolicitud
                        ? 'Formulario actualizado con éxito'
                        : `Enviado el: ${nowFormatted}`}
                </div>
            )}

            {/* ERRORES */}
            {errorCreate && (
                <div className="paragraph text-danger mb-4">
                    {errorCreate}
                </div>
            )}

            {errorUpdate && (
                <div className="paragraph text-danger mb-4">
                    {errorUpdate}
                </div>
            )}

            <ErrorList errors={errors} />


            {showSizeModal && (
                <>
                    <div className="modal fade show d-block" tabIndex={-1}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title text-white">Límite de tamaño excedido</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowSizeModal(false)}
                                    />
                                </div>

                                <div className="modal-body">
                                    <p>
                                        Has superado el límite de <strong>{MAX_SIZE_MB}MB</strong>.
                                    </p>
                                    <p>
                                        Debes adjuntar los documentos en varios envíos.
                                    </p>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setShowSizeModal(false)}
                                    >
                                        Entendido
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div className="modal-backdrop fade show"></div>
                </>
            )}
        </>
    );
};

export default FormBotonSubmit;